export const FETCH_SALES_MARKETS_REQUEST = 'FETCH_SALES_MARKETS_REQUEST';
export const FETCH_SALES_MARKETS_SUCCESS = 'FETCH_SALES_MARKETS_SUCCESS';
export const FETCH_SALES_MARKETS_FAILURE = 'FETCH_SALES_MARKETS_FAILURE';
